import { ProjectIcon } from "app/components/Icons";
import { renderLetter } from "app/containers/Features/containers/TeamSettings/components/ProjectIconSelection/helper";
import { IWorkspaceProjects } from "app/types";
import React from "react";

interface Props {
  selectedProject: IWorkspaceProjects;
}
const ProjectSelection: React.FC<Props> = ({ selectedProject }) => {
  const { avatar, projectName } = selectedProject;
  return (
    <button className="flex items-center justify-between w-full px-2 py-2 rounded hover:bg-gray-400 space-x-2 ">
      <span className="flex gap-2 text-xs text-secondary items-center ">
        <ProjectIcon size={20} color="#79808A" />
        Project:
      </span>
      <div className=" flex items-center justify-end gap-1 truncate ">
        <button
          style={{ backgroundColor: avatar.color }}
          className="flex !size-5 items-center justify-center rounded-[2px]"
        >
            {renderLetter(avatar, projectName, "", " text-secondary")}
        </button>
        <span className=" text-sm text-black font-normal truncate ">{projectName}</span>
      </div>
    </button>
  );
};

export default ProjectSelection;
